import { apiFetch } from './apiFetch';
import type { CancelReasonPayRule } from '@salaries/shared';

/** A cancellation reason the box can set a payout for, with its current %. */
export interface CancelReasonOption {
  cancel_reason_id: number;
  cancel_reason_name: string | null;
  percent: number;
  /** How often the reason appeared in the box's last ~3 months of classes. */
  recent_count: number;
}

export async function getCancelReasons(): Promise<CancelReasonOption[]> {
  return apiFetch<CancelReasonOption[]>('/cancel-reasons');
}

export async function updateCancelReasonRules(
  rules: CancelReasonPayRule[],
): Promise<CancelReasonPayRule[]> {
  return apiFetch<CancelReasonPayRule[]>('/cancel-reasons', {
    method: 'PUT',
    body: JSON.stringify({ rules }),
  });
}
